const SHARED_DEMO_PATHS = [
  "/workbench/504abda8e98a4611822b4ca1d3217f0d",
  "/workbench/84d796f37fea4e81b39cbddae57d5ba8_q0",
  "/dataset-studio/mkt_user_296901cbf52845658f",
];

/** Keep existing shared links working through their public live-demo routes. */
export function getLiveDemoRedirect({
  pathname,
  search,
  hash,
}: {
  pathname: string;
  search: string;
  hash: string;
}): string | null {
  const isSharedDemo = SHARED_DEMO_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
  if (!isSharedDemo) return null;

  return `/live-demo${pathname}${search}${hash}`;
}
